// Set REACT_APP_API_URL in .env.development.local to point `npm start` at a local backend.
export const API_URL = process.env.REACT_APP_API_URL || "https://testing-j8ci.onrender.com";
